if (!customElements.get('slideshow-component')) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('.slideshow__slide');
      this.pageCount = this.sliderItems.length;
      
      if (!this.slider || this.pageCount <= 1) return;

      this.currentPage = 0;
      this.autoplaySpeed = this.slider.dataset.speed * 1000 || 5000;
      this.autoplay = this.slider.dataset.autoplay === 'true';

      this.initPages();
      this.bindButtons();

      if (this.autoplay) {
        this.setAutoPlay();
      }
    }

    initPages() {
      this.sliderItems.forEach((slide, index) => {
        if (index === 0) {
          slide.setAttribute('aria-hidden', 'false');
          slide.style.setProperty('display', 'block');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.style.setProperty('display', 'none');
        }
      });
    }

    bindButtons() {
      const prevButton = this.querySelector('.slider-button--prev');
      const nextButton = this.querySelector('.slider-button--next');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          this.onButtonClick(-1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          this.onButtonClick(1);
        });
      }
    }

    onButtonClick(direction) {
      if (this.autoplay) {
        this.pauseAutoPlay();
        this.setAutoPlay();
      }
      
      this.currentPage += direction;
      
      if (this.currentPage < 0) {
        this.currentPage = this.pageCount - 1;
      } else if (this.currentPage >= this.pageCount) {
        this.currentPage = 0;
      }

      this.update();
    }

    update() {
      this.sliderItems.forEach((slide, index) => {
        if (index === this.currentPage) {
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('tabindex');
          slide.style.setProperty('display', 'block');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
          slide.style.setProperty('display', 'none');
        }
      });
    }

    setAutoPlay() {
      this.autoplayInterval = setInterval(() => {
        this.currentPage = (this.currentPage + 1) % this.pageCount;
        this.update();
      }, this.autoplaySpeed);
    }

    pauseAutoPlay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }
    }

    disconnectedCallback() {
      this.pauseAutoPlay();
    }
  }

  customElements.define('slideshow-component', SlideshowComponent);
}